/**
 * @file User / material analysis UI — pages/Dashboard/User/Home/components/OutputDownloadsSection.tsx.
 */

import React from "react";
import "../UserHome.css";

const OutputDownloadsSection: React.FC = () => {
  return (
    <div className="user-home-section">
      <div className="user-info-card">
        <h3 className="user-info-card-title">Output and downloads</h3>
        <p className="user-info-card-text">
          Once a valid dataset is retrieved, users can:
        </p>
        <ul className="user-info-list">
          <li>View representative embodied carbon values</li>
          <li>Understand the underlying data assumptions</li>
        </ul>
        <p className="user-info-card-text">
          Download results for:
        </p>
        <ul className="user-info-list">
          <li>LCA reports</li>
          <li>Academic research</li>
          <li>Policy or benchmarking studies</li>
        </ul>
        <p className="user-info-card-text">
          Each output is traceable and aligned with LCA best practices.
        </p>
      </div>
    </div>
  );
};

/** React component — Output Downloads Section. */
export default OutputDownloadsSection;
